module.exports = __webpack_public_path__ + "static/media/0.13f0d8b6.jpg";